import { operationKindLabel } from '../lib/status-labels';
import type { ModerationOperation } from '../lib/request-kind';
import type { Translate } from '../lib/translate';
import { MODERATION_PILL_BASE } from './moderation-status-pill';

/**
 * Operation hues come from the delivery palette (green / sky / red tints) —
 * hue-distinct from the status pill's brand-orange `pending`, so "what is
 * asked" never reads as "where it stands" when both pills sit side by side.
 */
const OPERATION_TONE: Record<ModerationOperation, string> = {
  create: 'bg-delivery-green-tint text-delivery-green',
  update: 'bg-delivery-sky-tint text-delivery-sky',
  delete: 'bg-delivery-red-tint text-delivery-red',
};

interface ModerationOperationPillProps {
  operation: ModerationOperation;
  t: Translate;
}

/** Operation pill (create / update / delete) in the status pill's geometry. */
export function ModerationOperationPill({ operation, t }: ModerationOperationPillProps) {
  return (
    <span
      data-operation={operation}
      className={`${MODERATION_PILL_BASE} ${OPERATION_TONE[operation]}`}
    >
      {operationKindLabel(operation, t)}
    </span>
  );
}
